/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createDocumentResponse2FromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, type DocumentResponse2, type ErrorResponse, type InternalErrorResponse } from '../../../../models/index.js';
// @ts-ignore
import { DownloadRequestBuilderRequestsMetadata, type DownloadRequestBuilder } from './download/index.js';
// @ts-ignore
import { MoveRequestBuilderRequestsMetadata, type MoveRequestBuilder } from './move/index.js';
// @ts-ignore
import { RefreshUrlRequestBuilderRequestsMetadata, type RefreshUrlRequestBuilder } from './refreshUrl/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/companydocs/documents/{documentId}
 */
export interface WithDocumentItemRequestBuilder extends BaseRequestBuilder<WithDocumentItemRequestBuilder> {
    /**
     * The download property
     */
    get download(): DownloadRequestBuilder;
    /**
     * The move property
     */
    get move(): MoveRequestBuilder;
    /**
     * The refreshUrl property
     */
    get refreshUrl(): RefreshUrlRequestBuilder;
    /**
     * Removes a document from the library and deletes the stored file. This is permanent — there is no recycle bin and no way to restore it, so re-upload is the only recovery. If the stored file cannot be removed the entry is still deleted, so the document always disappears from the library. An id belonging to another organization reads as not found. To remove several documents in one call, use the bulk-delete endpoint. Nothing is returned on success.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     delete(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * Returns one document's details. The cdnUrl is whatever link was issued last — it is time-limited and may already have expired, so treat a link that no longer works as normal and call the refresh-url endpoint, or stream the file through the download endpoint instead. Documents are scoped to the caller's organization: an id belonging to another organization reads as not found rather than as a refusal, so this endpoint never confirms that an id exists elsewhere.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<DocumentResponse2>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<DocumentResponse2 | undefined>;
    /**
     * Removes a document from the library and deletes the stored file. This is permanent — there is no recycle bin and no way to restore it, so re-upload is the only recovery. If the stored file cannot be removed the entry is still deleted, so the document always disappears from the library. An id belonging to another organization reads as not found. To remove several documents in one call, use the bulk-delete endpoint. Nothing is returned on success.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toDeleteRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * Returns one document's details. The cdnUrl is whatever link was issued last — it is time-limited and may already have expired, so treat a link that no longer works as normal and call the refresh-url endpoint, or stream the file through the download endpoint instead. Documents are scoped to the caller's organization: an id belonging to another organization reads as not found rather than as a refusal, so this endpoint never confirms that an id exists elsewhere.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const WithDocumentItemRequestBuilderUriTemplate = "{+baseurl}/api/companydocs/documents/{documentId}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const WithDocumentItemRequestBuilderNavigationMetadata: Record<Exclude<keyof WithDocumentItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    download: {
        requestsMetadata: DownloadRequestBuilderRequestsMetadata,
    },
    move: {
        requestsMetadata: MoveRequestBuilderRequestsMetadata,
    },
    refreshUrl: {
        requestsMetadata: RefreshUrlRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const WithDocumentItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    delete: {
        uriTemplate: WithDocumentItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/problem+json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
    },
    get: {
        uriTemplate: WithDocumentItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createDocumentResponse2FromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
